import { gql } from '@apollo/client';

// filtro para remover status false
export const GET_SPECIALTY = gql`
  query getSpecialty {
    specialties(order_by: { position: asc }, where: { status: { _eq: true } }) {
      derma_type
      id
      specialty
      status
      description
      img
      position
    }
  }
`;

export const GET_DOCTORS = gql`
  query getDoctors {
    doctors(where: { active: { _eq: true } }, limit: 12) {
      id
      active
      crm
      user {
        id
        firstname
        lastname
        city
        region
        image_url
      }
    }
  }
`;
